/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/modules/in-view.js":
/*!******************************************!*\
  !*** ./src/assets/js/modules/in-view.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InViewInit: () => (/* binding */ InViewInit)
/* harmony export */ });
/* harmony import */ var in_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! in-view */ "./node_modules/in-view/dist/in-view.min.js");
/* harmony import */ var in_view__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(in_view__WEBPACK_IMPORTED_MODULE_0__);

var InViewInit = function InViewInit() {
  /*
   * in-view アニメーション
   */

  in_view__WEBPACK_IMPORTED_MODULE_0___default()('.in-view').on('enter', function (el) {
    el.classList.add('is-in');
  });
};


/***/ }),

/***/ "./src/assets/js/modules/in_page_transition.js":
/*!*****************************************************!*\
  !*** ./src/assets/js/modules/in_page_transition.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InPageTransitionInit: () => (/* binding */ InPageTransitionInit)
/* harmony export */ });
var InPageTransitionInit = function InPageTransitionInit() {
  /*
   * ページ内遷移
   */

  var headerHeight = document.querySelector('.header').offsetHeight;
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);
      if (targetElement) {
        event.preventDefault();
        var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
};


/***/ }),

/***/ "./src/assets/js/modules/open_content.js":
/*!***********************************************!*\
  !*** ./src/assets/js/modules/open_content.js ***!
  \***********************************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  var faqContents = document.querySelectorAll('.faq_content');
  faqContents.forEach(function (content) {
    content.addEventListener('click', function () {
      this.classList.toggle('is-current');
    });
  });
});

/***/ }),

/***/ "./src/assets/js/modules/ua.js":
/*!*************************************!*\
  !*** ./src/assets/js/modules/ua.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   forDesktopOS: () => (/* binding */ forDesktopOS),
/* harmony export */   getBrowser: () => (/* binding */ getBrowser),
/* harmony export */   getOS: () => (/* binding */ getOS),
/* harmony export */   setUserAgent: () => (/* binding */ setUserAgent)
/* harmony export */ });
var getBrowser = function getBrowser() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('opera') !== -1) {
    ua = 'opera';
  } else if (userAgent.indexOf('edge') !== -1) {
    ua = 'edge';
  } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    ua = 'ie';
  } else if (userAgent.indexOf('chrome') !== -1) {
    ua = 'chrome';
  } else if (userAgent.indexOf('safari') !== -1) {
    ua = 'safari';
  } else if (userAgent.indexOf('firefox') !== -1) {
    ua = 'firefox';
  } else if (userAgent.indexOf('gecko') !== -1) {
    ua = 'gecko';
  }
  return ua;
};
var getOS = function getOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('iphone') !== -1) {
    ua = 'iphone';
  } else if (userAgent.indexOf('ipad') !== -1) {
    ua = 'ipad';
  } else if (userAgent.indexOf('android') !== -1) {
    ua = 'android';
  } else if (userAgent.indexOf('windows') !== -1) {
    ua = 'win';
  } else if (userAgent.indexOf('macintosh') !== -1) {
    ua = 'mac';
  }
  return ua;
};
var forDesktopOS = function forDesktopOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('windows') !== -1 || userAgent.indexOf('macintosh') !== -1;
};
var setUserAgent = function setUserAgent() {
  var body = document.querySelector('body');
  body.classList.add("is-".concat(getBrowser()));
  body.classList.add("is-".concat(getOS()));
  body.classList.add("is-".concat(forDesktopOS() ? 'for-pc' : 'for-sp'));
};


/***/ }),

/***/ "./node_modules/in-view/dist/in-view.min.js":
/*!**************************************************!*\
  !*** ./node_modules/in-view/dist/in-view.min.js ***!
  \**************************************************/
/***/ (function(module) {

/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){ true?module.exports=e():0}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/assets/js/app.js ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ua__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ua */ "./src/assets/js/modules/ua.js");
/* harmony import */ var _modules_open_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/open_content */ "./src/assets/js/modules/open_content.js");
/* harmony import */ var _modules_open_content__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_open_content__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_in_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/in-view */ "./src/assets/js/modules/in-view.js");
/* harmony import */ var _modules_in_page_transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/in_page_transition */ "./src/assets/js/modules/in_page_transition.js");




var loadCommonInit = function loadCommonInit() {
  (0,_modules_ua__WEBPACK_IMPORTED_MODULE_0__.setUserAgent)();
  (0,_modules_in_page_transition__WEBPACK_IMPORTED_MODULE_3__.InPageTransitionInit)();
  (0,_modules_in_view__WEBPACK_IMPORTED_MODULE_2__.InViewInit)();
};
window.addEventListener('DOMContentLoaded', function () {
  loadCommonInit();

  // 監視対象の要素を取得
  var targets = document.querySelectorAll('.item');

  // オプションの設定
  var options = {
    root: null,
    // ビューポートを基準にする
    rootMargin: '0px',
    // マージンの調整（必要に応じて変更可能）
    threshold: 0 // 要素が50%見えたら発火
  };

  // コールバック関数
  var callback = function callback(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible'); // クラスを追加
      }
    });
  };

  // Intersection Observerの作成
  var observer = new IntersectionObserver(callback, options);

  // 各要素を監視
  targets.forEach(function (target) {
    return observer.observe(target);
  });
  // .btn-zoomをクリックして.is-currentクラスを追加

  document.querySelector('.btn-zoom').addEventListener('click', function (event) {
    event.stopPropagation(); // クリックイベントのバブリングを防止
    document.querySelector('.zoom-item').classList.add('is-current');
  });

  // .btn-zoom クリック時に .zoom-item に .is-current クラスを追加
  document.querySelector('.btn-zoom').addEventListener('click', function () {
    var zoomItem = document.querySelector('.zoom-item');
    zoomItem.classList.add('is-current');
  });

  // 全体のクリックを監視
  document.querySelector('body').addEventListener('click', function (event) {
    var zoomItem = document.querySelector('.zoom-item');

    // zoomItemに.is-currentがついている、かつ.img-zoom以外の要素がクリックされた場合
    if (zoomItem.classList.contains('is-current') && !event.target.closest('.img-zoom') && !event.target.closest('.btn-zoom')) {
      zoomItem.classList.remove('is-current');
    }
  });
  // .skip クリック時に body に .is-current クラスを追加
  document.querySelector('.skip').addEventListener('click', function () {
    document.body.classList.add('is-current');
  });

  // 動画の再生終了を検知
  var video = document.querySelector(".opening-video video");
  if (video) {
    video.addEventListener("ended", function () {
      document.body.classList.add("is-current");
    });
  }
});
})();

/******/ })()
;
//# sourceMappingURL=medulluxCombironApp.js.map